import React, { useState } from "react";
import { svg } from "../../../Assets/svg";
import VariantPickerModal from "./Components/VariantPickerModal";
import BOMDetails from "../Quotations/Components/BOMDetails";
import { useAppDispatch } from "../../../store";
import { generateBomAPI } from "../Quotations/quotationApis";

const BOMSearch = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVariants, setSelectedVariants] = useState<any[]>([]);
  const [bomData, setBomData] = useState<any>(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const dispatch = useAppDispatch();



  const handleGenerateBOM = (updatedVariants?: any[]) => {
    setIsGenerating(true);
    const targetVariants = updatedVariants || selectedVariants;
    const payload = targetVariants.map((v: any) => ({
      variant_id: v.variant_id || v._id,
      qty: v.qty || 1,
    }));
    
    dispatch(
      generateBomAPI({
        payload,
        onSuccess: (data: any) => {
          const rawItems = Array.isArray(data) ? data : data?.data || [];
          setBomData({ bom_details: rawItems });
          setIsModalOpen(false);
          setIsGenerating(false);
        },
        onError: () => {
          setIsGenerating(false);
        },
      })
    );
  };

  return (
    <div className="page-content h-100 px-md-40 px-3 py-md-40 py-3 pb-0 d-flex flex-column">
      <div className="mb-md-3 mb-2 d-flex flex-column gap-md-2 gap-0">
        <div className="d-flex flex-md-nowrap flex-wrap gap-md-3 gap-2 justify-content-between align-items-center">
          <h2 className="text-black fw-bolder page-title mb-0 order-sm-1 order-1 d-flex align-items-center gap-2">
            BOM Search
          </h2>
          <div className="d-flex justify-content-end align-items-center order-sm-3 order-2 ms-sm-0 ms-auto gap-2">
            {bomData ? (
              <>
               <button
                  className="btn btn-lg btn-outline-danger fw-semibold mob-btn"
                  onClick={() => {
                    setSelectedVariants([]);
                    setBomData(null);
                  }}
                >
                  CLEAR SEARCH
                </button>
                <button
                  className="btn btn-lg btn-outline-secondary fw-semibold mob-btn"
                  onClick={() => setIsModalOpen(true)}
                >
                  EDIT SELECTION
                </button>
               
              </>
            ) : (
              <button
                className="btn btn-lg btn-primary mob-btn"
                onClick={() => setIsModalOpen(true)}
              >
                + SELECT VARIANTS
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="card page-table-card border-0 shadow rounded-4 flex-fill overflow-hidden mb-lg-0 mb-3">
        <div className={`card-body ${!bomData ? "d-flex justify-content-center align-items-center flex-column" : "p-0"}`}>
          {!bomData ? (
            <div className="d-flex flex-column justify-content-center align-items-center py-5 text-center px-4">
              <span className="svg-60 d-inline-block mb-4 text-muted">
                {svg?.bomSearchIcon || svg?.noQuotationIcon}
              </span>
              <p className="fs-5 fw-medium text-black mb-4">
                Please select product variants to generate and view their combined Bill of Materials.
              </p>
              <button
                className="btn btn-lg btn-primary px-4"
                onClick={() => setIsModalOpen(true)}
              >
                SELECT VARIANTS
              </button>
            </div>
            
          ) : (
            <div className="h-100 w-100 overflow-y-auto d-flex flex-column">
              <div className="d-flex align-items-center p-3 border-bottom sticky-top bg-white z-1">
                <div className="d-flex gap-2 flex-wrap align-items-center">
                  <span className="fw-semibold text-muted me-1 fs-7">Selected:</span>
                  {selectedVariants.map((v, i) => (
                    <span key={i} className="badge bg-light text-dark border px-2 py-1 fs-7">
                      {v.variantData?.variant_name || v.variant_name || v.name || "Variant"} - {v.qty || 1} Qty
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-3">
                <BOMDetails data={bomData} selectedVariants={selectedVariants} showNavigationButtons={false} />
              </div>
            </div>
          )}
        </div>
      </div>

      {isModalOpen && <VariantPickerModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItems={selectedVariants}
        onSelectionChange={setSelectedVariants}
        onGenerateBOM={handleGenerateBOM}
        isGenerating={isGenerating}
      />}
    </div>
  );
};

export default BOMSearch;
